import { Injectable } from '@angular/core';
import { databases, ID, storage } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { Grupo } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ParentescoService {

  constructor() { }

  private collectionId = "parentescos";
  private DATABASE_NAME = environment.databaseName;


  /**
   * @getData()
   * @returns
   */
  getData(): Promise<Grupo[]> {
    return databases.listDocuments<Grupo>(
      this.DATABASE_NAME,
      this.collectionId
    ).then(response => response.documents);
  }


}
